import { ReactNode } from 'react'

export function CommentBottomSection({ children }: { children: ReactNode }) {
  return (
    <div className="flex w-full flex-row justify-between text-[14px]">
      {children}
    </div>
  )
}
